import { Fetcher } from "../Fetcher";
import { PartialRightsRequestInfos } from "@/types/front/PartialRightsRequestInfos";
import {
  CreateRightsRequestRequest,
  GetRightsRequestResult,
  RightsRequestResult,
} from "@/types/generated/UsedGeneratedTypes";

/**
 * Payload envoyé au backend lors de la validation du traitement d'une
 * demande de droits par un gestionnaire ( #487 Phase 3 ).
 */
export interface TreatRightsRequestPayload {
  status: "APPROVED" | "REJECTED";
  linkedAuthorizationIds: string[];
  treatmentComment: string;
  mailSubject: string;
  mailBody: string;
  suppressMail: boolean;
}

export class RequestRightsService extends Fetcher {
  static INSTANCE = new RequestRightsService();

  constructor() {
    super();
  }

  async getRightsRequests(
    applicationName: string,
    params?: PartialRightsRequestInfos,
  ): Promise<GetRightsRequestResult> {
    if (params) {
      return this.get(
        `applications/${applicationName}/rightsRequest`,
        { params: JSON.stringify(params) },
        false,
      );
    }
    else {
      return this.get(`applications/${applicationName}/rightsRequest`);
    }
  }

  async createRequestRights(
    applicationName: string,
    requestRights: CreateRightsRequestRequest,
  ): Promise<string> {
    return this.post(
      `applications/${applicationName}/rightsRequest`,
      requestRights,
      false,
    );
  }

  /**
   * Marque la demande de droits comme traitée et persiste l'identité du
   * gestionnaire courant. Le backend renvoie la demande à jour pour que
   * le frontend puisse rafraîchir son listing sans relancer de GET.
   */
  async treatRequest(
    applicationName: string,
    requestId: string,
    payload: TreatRightsRequestPayload,
  ): Promise<RightsRequestResult> {
    return this.put(
      `applications/${applicationName}/rightsRequest/${requestId}/treat`,
      payload,
      false,
    );
  }
}
